import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import css from './index.module.scss';

interface InstallationPopupProps {
    callInstallation: React.Dispatch<React.SetStateAction<boolean>>;
    list?: string[];
    numList?: string[];
    listTitle?: ReactNode;
    title: ReactNode;
    desc?: string;
    needCount?: boolean;
}

export default function InstallationPopup({ callInstallation, list, title, desc, numList, needCount = true, listTitle }: InstallationPopupProps) {
    return ReactDOM.createPortal(
        <div className={`head-popup ${css['head-popup']}`}>
            <div className="head-popup-content">
                <svg
                    className="head-popoup-close"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    onClick={() => callInstallation(false)}
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="10" cy="10" r="10" fill="white" fillOpacity="0.4" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.1872 7.53033C13.4801 7.23744 13.4801 6.76256 13.1872 6.46967C12.8943 6.17678 12.4194 6.17678 12.1265 6.46967L9.82873 8.76746L7.53093 6.46967C7.23804 6.17678 6.76317 6.17678 6.47027 6.46967C6.17738 6.76256 6.17738 7.23744 6.47027 7.53033L8.76807 9.82812L6.46967 12.1265C6.17678 12.4194 6.17678 12.8943 6.46967 13.1872C6.76256 13.4801 7.23744 13.4801 7.53033 13.1872L9.82873 10.8888L12.1271 13.1872C12.42 13.4801 12.8949 13.4801 13.1878 13.1872C13.4807 12.8943 13.4807 12.4194 13.1878 12.1265L10.8894 9.82812L13.1872 7.53033Z"
                        fill="white"
                    />
                </svg>
                <p className="head-title">{title}</p>
                <p className="head-desc">{desc}</p>
                {listTitle && <p className="head-list-title head-desc">{listTitle}</p>}
                {list && (
                    <ul className="head-list-text">
                        {list?.map((item: any, k: number) => (
                            <li className="head-list-text-item" key={k}>
                                <span className="head-list-text-step">{k + 1}.</span>
                                <span className="head-list-text-text">{item}</span>
                            </li>
                        ))}
                    </ul>
                )}
                {numList && needCount && (
                    <ul className="head-list">
                        {numList?.map((item: any, k: number) => (
                            <li className="head-list-item" key={k}>
                                <span className="head-list-step">{k + 1}</span>
                                <span className="head-list-text">{item}</span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>,
        document.body,
    );
}
